<template>
  <div class="messageList">
    <div class="messageList_top">
      <el-button size='mini'
                 type="primary"
                 @click="allReadMessage">全部已读</el-button>
    </div>
    <el-table :data="tableData"
              style="width: 100%">
      <el-table-column prop="create_time"
                       label="时间"
                       width="200">
      </el-table-column>
      <el-table-column label="内容">
        <template slot-scope='scope'>
          <el-tooltip class="scope_item"
                      effect="dark"
                      :content="scope.row.message"
                      placement="top"
                      transition='el-zoom-in-bottom'>
            <span class="scope_item_show">{{scope.row.message}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="类型"
                       width="180">
        <template slot-scope='scope'>
          {{scope.row.type|showTextView}}
        </template>

      </el-table-column>
      <el-table-column label="状态"
                       width="180">
        <template slot-scope='scope'>
          <div :style='scope.row.is_read==0?"color:#f10":""'>
            {{scope.row.is_read==1?'已读':'未读'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align='right'
                       label="操作">
        <template slot-scope='scope'>
          <div class="operation">
            <el-button type="primary"
                       size='mini'
                       v-if="scope.row.sign&&(scope.row.type==1||scope.row.type==3)"
                       @click='skipClick(scope.row)'>{{'查看'}}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   layout="prev, pager, next"
                   :page-size='15'
                   :current-page.sync='page'
                   :total="pageSize"
                   @current-change='getMessageList'>
    </el-pagination>
  </div>
</template>

<script>
import common from '@/assets/js/common'
import { postMessage, allRead } from '@/request/api'
export default {
  data () {
    return {
      // 通知列表
      tableData: [],
      // 通知数量
      pageSize: 0,
      // 当前页码
      page: 0,
    }
  },
  filters: {
    showTextView (e) {
      if (e == 1) {
        return '订单通知'
      } else if (e == 2) {
        return '系统通知'
      } else if (e == 3) {
        return '用户通知'
      } else if (e == 4) {
        return '其他'
      }
      return ''
    },
  },
  methods: {
    // -------------- [ 全部已读 ] --------------
    allReadMessage () {
      this.$confirm('是否将所有消息设置已读?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.readMessage()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // -------------- [ 已读消息 ] --------------
    async readMessage (type, id) {
      let res = await allRead({
        id: type ? id : '',
        all: type ? '' : 1
      })
      if (!type) {
        this.$message.success(res.message)
      }
    },
    // -------------- [ 点击跳转 ] --------------
    async skipClick (row) {
      if (row.is_read == 0) {
        this.readMessage(true, row.id)
      }
      if (row.sign) {
        if (row.type == 1) {
          this.$router.push({
            name: 'allOrders',
            params: {
              id: row.sign
            }
          })
        } else if (row.type == 3) {
          this.$router.push({
            name: Userinfo
          })
        }
      }

    },
    // --------- [ 获取通知 ] ---------
    async getMessageList () {
      let res = await postMessage({
        pageSize: 15,
        page: this.page,

      })
      if (res.errno == 0) {
        let arr = []
        for (const key in res.tzlist) {
          res.tzlist[key].create_time = common.formatDate(res.tzlist[key].create_time)
          arr.push(res.tzlist[key])
        }
        this.tableData = arr
        this.pageSize = parseInt(res.totalNum)
      }
    }
  },
  created () {
    this.getMessageList()
  }
}
</script>

<style lang='scss'>
.messageList {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  min-height: 1000px;
  .messageList_top {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .scope_item_show {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
}
</style>